import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import Home from "./components/Home";
import Map from "./components/Map";
import Record from "./components/Record";
import Notification from "./components/Notification";
import LoginPage from "./components/LoginPage";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
    },
    {
        path: '/map',
        element: <Map />
    },
    {
        path: '/notification',
        element: <Notification />
    },
    {
        path: '/loginpage',
        element: <LoginPage />
    }
];

export default AppRoutes;
